import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FindPipe } from './find.pipe';



@NgModule({
  declarations: [
    FindPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FindPipe
  ]
})
export class FindModule { }
